import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import citiesHeaders from "@/pages/Maintenance/Cities/citiesHeaders";

export default {
	state: {
		citiesItem: null,
		citiesList: null,
		citiesFilters: null,
		citiesTotals: null,
		citiesLimit: null,
		citiesOrder: null,
		citiesSort: null,
		citiesTotal: null,
		statesList: null,
	},
	mutations: {
		updateCitiesList(state, { row, limit, order, sort, total }) {
			state.citiesList = row;
			state.citiesLimit = limit;
			state.citiesOrder = order;
			state.citiesSort = sort;
			state.citiesTotal = total;
			state.citiesTotals = { id: total };
		},
		updateCitiesFilters(state, { filter }) {
			state.citiesFilters = filter;
		},
		getDriverDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDriverDeleteFiles', { id, isDelete });
		},
		updateCitiesItem(state, { city }) {
			state.citiesItem = city;
		},
		updateStatesList(state, { states }) {
			state.statesList = states;
		}
	},
	actions: {
		async getCities({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/city/list', filters);

				if (data && !data.status) {
					commit('updateCitiesList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.CITIES, defaultHeader: citiesHeaders });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getCitiesFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/city/filters', values);
				if (data) commit('updateCitiesFilters', data);
			} catch (e) {
				console.error(e);
			}
		},
		async onCitiesSave({ dispatch }, { id, ...values }) {
			dispatch("actionPreloader", true);
			const requestKey = id ? 'put' : 'post';
			const requestUri = id ? `/city/${ id }` : '/city';
			try {
				const { data } = await httpClient[requestKey](requestUri, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async onCitiesRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/city/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getCitiesItem({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/city/${ id }/edit`);

				if (data && !data.status) {
					commit("updateCitiesItem", data);
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getStatesList({ commit }) {
			try {
				const { data } = await httpClient.post('/states');
				if (data) commit('updateStatesList', data);
			} catch (e) {
				console.error(e);
			}
		}
	},
	getters: {
		citiesItem: (s) => s.citiesItem,
		citiesList: (s) => s.citiesList,
		citiesFilters: (s) => s.citiesFilters,
		citiesTotals: (s) => s.citiesTotals,
		citiesLimit: (s) => s.citiesLimit,
		citiesOrder: (s) => s.citiesOrder,
		citiesSort: (s) => s.citiesSort,
		citiesTotal: (s) => s.citiesTotal,
		statesList: (s) => s.statesList,
	}
};
